// Seletores de ícone e de capa das páginas, como no Notion: emoji (com
// categorias e recentes), ícones coloridos, imagem enviada ou link.

import { uploadFile } from "./api.js";
import { el, popup, toast, safeGet, safeSet } from "./dom.js";
import { PAGE_ICONS, ICON_COLORS, svg, ui } from "./icons.js";
import { adjustAndUpload, imageFromTransfer, imageUrlFromTransfer } from "./image-adjust.js";

const EMOJI_GROUPS = [
  ["Pessoas", "😀 😃 😄 😁 😆 😅 😂 🙂 😉 😊 😇 🥰 😍 🤩 😎 🤓 🧐 🤔 🤨 😐 😴 🤯 🥳 😤 😡 🤝 👍 👎 👏 🙌 🙏 💪 👀 🧠 👤 👥 🧑‍💻 👩‍💻 👨‍💻 🧑‍🔬 🧑‍⚕️ 🧑‍🏫 🧑‍💼 🦸 🕵️"],
  ["Trabalho", "📄 📝 📌 📍 📎 🖇️ 📁 📂 🗂️ 🗃️ 🗄️ 📋 📊 📈 📉 📅 📆 🗓️ ✅ ☑️ ✔️ 📥 📤 📦 📫 ✉️ 📧 💼 🧾 💰 💵 💳 🏦 🏢 🏛️ 🏭 🖊️ ✏️ 🖍️ 📏 📐 🔖 🏷️"],
  ["Tecnologia", "💻 🖥️ ⌨️ 🖱️ 📱 📲 ☎️ 📞 🖨️ 💾 💿 🔌 🔋 📡 🛰️ 🤖 👾 🧩 🛠️ 🔧 🔨 ⚙️ 🧰 🧪 🧫 🧬 🔬 🔭 🐞 🐛 🚀 🛸 🔐 🔒 🔓 🔑 🗝️ 🌐 ☁️ 🧱"],
  ["Ideias", "💡 🎯 🔥 ⭐ 🌟 ✨ ⚡ 💥 🎉 🎊 🏆 🥇 🥈 🥉 🏅 🎖️ 🧭 🗺️ 🧠 📣 📢 🔔 💬 💭 🗨️ 🗯️ ❗ ❓ ⚠️ 🚧 🚨 ⏰ ⏳ ⌛ 🕒 🔁 🔄 ♻️"],
  ["Saúde", "🩺 🏥 💊 💉 🩹 🩻 🚑 🧑‍⚕️ ❤️‍🩹 🫀 🫁 🦷 🦴 🧘 🏃 🚴 🏋️ ⚕️ 🧴 🧼 😷 🤒"],
  ["Natureza", "🌱 🌿 🍀 🌳 🌲 🌴 🌵 🌻 🌸 🌺 🌷 🍁 🍂 🌎 🌍 🌙 ☀️ ⛅ 🌧️ ⛈️ ❄️ 🌊 🔥 💧 🐶 🐱 🦊 🐻 🐼 🐨 🦁 🐯 🐸 🐵 🦉 🐝 🦋 🐢 🐙 🐳"],
  ["Comida", "☕ 🍵 🧃 🥤 🍺 🍷 🍕 🍔 🌭 🌮 🍣 🍜 🍝 🥗 🥪 🍎 🍌 🍇 🍓 🥑 🥕 🌽 🍞 🧀 🍰 🎂 🍪 🍫 🍿"],
  ["Lugares", "🏠 🏡 🏘️ 🏙️ 🌆 🏖️ 🏔️ 🗻 🏕️ 🚗 🚕 🚌 🚚 🚜 ✈️ 🚂 🚢 ⛵ 🛒 🎓 🏫 ⛪ 🏟️ 🎪 🎡 🗽 🗼"],
  ["Atividades", "⚽ 🏀 🏈 ⚾ 🎾 🏐 🎱 🏓 🎮 🕹️ 🎲 ♟️ 🎯 🎳 🎨 🎬 🎤 🎧 🎵 🎶 🎸 🎹 🥁 📷 📸 🎥 📺 📻 📚 📖 🎁"],
  ["Símbolos", "❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💯 ✅ ❎ ➕ ➖ ✖️ ➗ ♾️ ‼️ ⁉️ 🔴 🟠 🟡 🟢 🔵 🟣 ⚫ ⚪ 🟥 🟧 🟨 🟩 🟦 🟪 ⬛ ⬜ 🔺 🔻 🔷 🔶 ▶️ ⏸️ ⏹️ ⏺️ #️⃣ 🔢 🆕 🆗 🆙 🆒 🆓"],
].map(([name, list]) => [name, list.split(" ")]);

const ICON_LABELS = {
  "file-text": "documento", "notebook-pen": "caderno", "book-open": "livro", bookmark: "marcador", briefcase: "trabalho maleta", building: "empresa prédio",
  calendar: "calendário", "calendar-check": "agenda", "calendar-days": "dias", "chart-column": "gráfico barras", "chart-line": "gráfico linha",
  "square-check": "tarefa check", "circle-check": "concluído", "clipboard-list": "lista checklist", clock: "relógio hora", code: "código",
  settings: "configurações engrenagem", cpu: "processador", database: "banco dados", flag: "bandeira", flask: "laboratório teste", folder: "pasta",
  "folder-kanban": "projeto", gift: "presente", globe: "mundo web", "graduation-cap": "estudo curso", hammer: "martelo", heart: "coração",
  house: "casa início", inbox: "caixa entrada", key: "chave senha", kanban: "quadro kanban", "kanban-cols": "colunas", layers: "camadas ambiente",
  dashboard: "painel", lightbulb: "ideia", link: "link", "list-checks": "checklist", "list-todo": "tarefas", lock: "cadeado privado", mail: "email",
  map: "mapa", megaphone: "anúncio", message: "mensagem chat", mic: "microfone reunião", monitor: "tela", package: "pacote entrega", palette: "design cores",
  paperclip: "anexo", pencil: "lápis editar", phone: "telefone", pin: "fixar", play: "play vídeo", puzzle: "quebra-cabeça integração", rocket: "lançamento foguete",
  search: "busca", send: "enviar", server: "servidor", shield: "segurança", cart: "compras", smartphone: "celular app", sparkles: "ia mágica",
  star: "estrela favorito", stethoscope: "saúde médico", tag: "etiqueta", target: "meta alvo", terminal: "terminal", "test-tube": "teste qa",
  "thumbs-up": "aprovado", timer: "cronômetro", "trending-up": "crescimento", trophy: "troféu", truck: "caminhão", user: "pessoa", users: "time equipe",
  video: "vídeo", wallet: "carteira financeiro", wrench: "ferramenta", zap: "rápido", bug: "bug defeito", bell: "notificação", box: "caixa",
  camera: "câmera", coffee: "café", crown: "coroa", dollar: "dinheiro", "file-check": "aprovado documento", "git-branch": "branch git",
  hospital: "hospital", landmark: "banco governo", headset: "suporte", handshake: "acordo cliente", receipt: "recibo nota", activity: "atividade",
  brain: "cérebro", bot: "robô", "notebook-tabs": "agenda", ticket: "ticket chamado",
};

const recentEmojis = () => safeGet("ordo.recentEmojis", []);
const remember = (v) => safeSet("ordo.recentEmojis", [v, ...recentEmojis().filter((x) => x !== v)].slice(0, 24));
const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// onPick(valor | null). Valor: emoji, "lucide:nome:cor" ou URL de imagem.
export function iconPicker(anchor, onPick, { current } = {}) {
  let tab = current?.startsWith("lucide:") ? "icons" : "emoji";
  let color = current?.startsWith("lucide:") ? current.split(":")[2] : "default";
  const body = el("div", { class: "picker-body" });
  const search = el("input", { class: "pop-input", placeholder: "Filtrar…" });
  const choose = (v) => { box.close(); if (v && !v.startsWith("lucide:") && !/^https?:/.test(v)) remember(v); onPick(v); };
  const tabs = el("div", { class: "picker-tabs" });
  const tabBtn = (id, label) => el("button", { class: "picker-tab" + (tab === id ? " on" : ""), onclick: () => { tab = id; draw(); } }, label);

  const draw = () => {
    tabs.replaceChildren(tabBtn("emoji", "Emoji"), tabBtn("icons", "Ícones"), tabBtn("upload", "Enviar"), tabBtn("link", "Link"),
      el("span", { class: "grow" }),
      el("button", { class: "link small", onclick: () => {
        const all = EMOJI_GROUPS.flatMap(([, l]) => l);
        choose(all[Math.floor(Math.random() * all.length)]);
      } }, "Aleatório"),
      el("button", { class: "link small", onclick: () => choose(null) }, "Remover"));
    search.hidden = !(tab === "emoji" || tab === "icons");
    const q = norm(search.value.trim());
    if (tab === "emoji") {
      const recent = recentEmojis();
      const groups = q ? [] : [recent.length ? ["Recentes", recent] : null, ...EMOJI_GROUPS].filter(Boolean);
      body.replaceChildren(...(q
        ? [el("p", { class: "muted small" }, "Para buscar por nome, use a aba Ícones. Aqui você também pode colar um emoji:"),
          el("button", { class: "small", onclick: () => choose(search.value.trim()) }, `Usar "${search.value.trim()}"`)]
        : groups.map(([name, list]) => el("div", { class: "picker-group" }, el("div", { class: "picker-label" }, name),
          el("div", { class: "emoji-grid" }, list.map((e) => el("button", { class: "emoji", title: e, onclick: () => choose(e) }, e)))))));
    } else if (tab === "icons") {
      const names = Object.keys(PAGE_ICONS).filter((n) => !q || norm(n + " " + (ICON_LABELS[n] || "")).includes(q));
      body.replaceChildren(
        el("div", { class: "color-row" }, Object.entries(ICON_COLORS).map(([c, hex]) => el("button", {
          class: "color-dot" + (c === color ? " on" : ""), title: c, style: { background: hex }, onclick: () => { color = c; draw(); } }))),
        el("div", { class: "icon-grid" }, names.map((n) => el("button", { class: "icon-cell", title: ICON_LABELS[n] || n, onclick: () => choose(`lucide:${n}:${color}`) },
          svg(PAGE_ICONS[n], { size: 22, color: ICON_COLORS[color], stroke: 2 })))),
        names.length ? null : el("p", { class: "muted small" }, "Nenhum ícone com esse nome."));
    } else if (tab === "upload") {
      body.replaceChildren(uploadBox(useFile, "PNG, JPG, GIF ou SVG, até 5 MB. Depois você ajusta o enquadramento."));
    } else {
      body.replaceChildren(linkBox((url) => choose(url), "Cole o link de uma imagem (https://…)"));
    }
  };
  // Imagem escolhida, colada ou arrastada: ajustar o enquadramento e enviar.
  const useFile = async (file) => {
    if (file.size > 5 * 1024 * 1024) return toast("A imagem passa de 5 MB.");
    box.close();
    const url = await adjustAndUpload(file, { shape: "square", title: "Ajustar ícone" });
    if (url) onPick(url);
  };
  // Ctrl+V com o seletor aberto: imagem copiada (print, imagem do navegador,
  // arquivo) ou link de imagem, como no Notion.
  const onPaste = (e) => {
    const file = imageFromTransfer(e.clipboardData);
    if (file) { e.preventDefault(); useFile(file); return; }
    const url = imageUrlFromTransfer(e.clipboardData);
    if (url) { e.preventDefault(); choose(url); }
  };
  const onDrop = (e) => {
    const file = imageFromTransfer(e.dataTransfer);
    if (!file) return;
    e.preventDefault();
    useFile(file);
  };
  search.addEventListener("input", draw);
  search.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && tab === "emoji" && search.value.trim()) choose(search.value.trim());
  });
  const box = popup(anchor, el("div", { class: "picker" }, tabs, search, body,
    el("div", { class: "picker-paste-hint muted small" }, ui("paste", 13), " Dica: copie uma imagem e cole aqui com Ctrl+V")),
  { className: "picker-pop", onClose: () => document.removeEventListener("paste", onPaste, true) });
  document.addEventListener("paste", onPaste, true);
  box.addEventListener("dragover", (e) => { if ([...(e.dataTransfer?.types || [])].includes("Files")) e.preventDefault(); });
  box.addEventListener("drop", onDrop);
  draw();
  requestAnimationFrame(() => search.focus());
  return box;
}

// Escolher arquivo (ou arrastar para cá). onFile(file) decide o que fazer.
function uploadBox(onFile, hint) {
  const input = el("input", { type: "file", accept: "image/*", hidden: true });
  const btn = el("button", { class: "primary", onclick: () => input.click() }, ui("upload", 14), " Escolher imagem");
  input.addEventListener("change", () => {
    const f = input.files?.[0];
    if (f) onFile(f);
  });
  return el("div", { class: "picker-upload picker-drop" }, input, btn,
    el("p", { class: "muted small" }, "Ou arraste uma imagem para cá, ou cole com Ctrl+V."),
    el("p", { class: "muted small" }, hint));
}

// Envia sem ajustar (capas), mostrando o andamento no próprio seletor.
async function uploadDirect(file, maxMb, done) {
  if (file.size > maxMb * 1024 * 1024) return toast(`A imagem passa de ${maxMb} MB.`);
  toast("Enviando a imagem…", 60000);
  try {
    const { url } = await uploadFile(file, file.name || "capa.png");
    toast("Imagem salva.", 1500);
    done(url);
  } catch (err) {
    toast("Não foi possível enviar: " + err.message);
  }
}

function linkBox(done, placeholder) {
  const input = el("input", { class: "pop-input", placeholder });
  const go = () => {
    const v = input.value.trim();
    if (!/^https:\/\/\S+$/i.test(v)) return toast("Use um link que comece com https://");
    done(v);
  };
  input.addEventListener("keydown", (e) => { if (e.key === "Enter") go(); });
  requestAnimationFrame(() => input.focus());
  return el("div", { class: "picker-upload" }, input, el("button", { class: "primary", onclick: go }, "Usar este link"));
}

// ---------- Capas ----------

export const GRADIENTS = [
  "linear-gradient(120deg, #0f2027, #203a43 50%, #2c5364)",
  "linear-gradient(120deg, #1d2b64, #3b4c9c 55%, #6a7fdb)",
  "linear-gradient(120deg, #ff9a8b, #ff6a88 55%, #ff99ac)",
  "linear-gradient(120deg, #43cea2, #185a9d)",
  "linear-gradient(120deg, #f6d365, #fda085)",
  "linear-gradient(120deg, #a18cd1, #fbc2eb)",
  "linear-gradient(120deg, #0b3d2e, #1f7a5a 60%, #63c29a)",
  "linear-gradient(120deg, #141e30, #243b55)",
  "linear-gradient(120deg, #e0eafc, #cfdef3)",
  "linear-gradient(120deg, #ee9ca7, #ffdde1)",
  "linear-gradient(120deg, #2b1055, #7597de)",
  "linear-gradient(120deg, #3a1c71, #d76d77 55%, #ffaf7b)",
];
const COVER_COLORS = { red: "#e16259", orange: "#f2994a", yellow: "#f2c94c", green: "#4dab9a", blue: "#529cca", purple: "#9a6dd7", pink: "#e255a1", gray: "#9b9a97", brown: "#a0745a", dark: "#2f3437" };

// Fundo CSS de uma capa ("gradient:3", "color:blue" ou URL de imagem).
export function coverCss(value) {
  if (!value) return null;
  if (value.startsWith("gradient:")) return GRADIENTS[Number(value.slice(9))] || GRADIENTS[0];
  if (value.startsWith("color:")) return COVER_COLORS[value.slice(6)] || COVER_COLORS.gray;
  if (/^https?:/i.test(value)) return `center / cover no-repeat url("${value.replace(/["\\]/g, "")}")`;
  return null;
}

export function randomCover() {
  return `gradient:${Math.floor(Math.random() * GRADIENTS.length)}`;
}

export function coverPicker(anchor, onPick) {
  let tab = "gallery";
  const body = el("div", { class: "picker-body" });
  const tabs = el("div", { class: "picker-tabs" });
  const choose = (v) => { box.close(); onPick(v); };
  const draw = () => {
    tabs.replaceChildren(
      ...[["gallery", "Galeria"], ["upload", "Enviar"], ["link", "Link"]].map(([id, label]) =>
        el("button", { class: "picker-tab" + (tab === id ? " on" : ""), onclick: () => { tab = id; draw(); } }, label)),
      el("span", { class: "grow" }),
      el("button", { class: "link small", onclick: () => choose(null) }, "Remover"));
    if (tab === "gallery") {
      body.replaceChildren(
        el("div", { class: "picker-label" }, "Degradês"),
        el("div", { class: "cover-grid" }, GRADIENTS.map((g, i) => el("button", { class: "cover-cell", style: { background: g }, onclick: () => choose(`gradient:${i}`) }))),
        el("div", { class: "picker-label" }, "Cores"),
        el("div", { class: "cover-grid" }, Object.entries(COVER_COLORS).map(([c, hex]) => el("button", { class: "cover-cell", style: { background: hex }, onclick: () => choose(`color:${c}`) }))));
    } else if (tab === "upload") {
      body.replaceChildren(uploadBox((f) => uploadDirect(f, 10, choose), "Imagens com mais de 1500 px de largura ficam melhores (até 10 MB)."));
    } else {
      body.replaceChildren(linkBox((url) => choose(url), "Cole o link de uma imagem (https://…)"));
    }
  };
  const onPaste = (e) => {
    const file = imageFromTransfer(e.clipboardData);
    if (file) { e.preventDefault(); uploadDirect(file, 10, choose); return; }
    const url = imageUrlFromTransfer(e.clipboardData);
    if (url) { e.preventDefault(); choose(url); }
  };
  const box = popup(anchor, el("div", { class: "picker" }, tabs, body,
    el("div", { class: "picker-paste-hint muted small" }, ui("paste", 13), " Dica: copie uma imagem e cole aqui com Ctrl+V")),
  { className: "picker-pop", align: "right", onClose: () => document.removeEventListener("paste", onPaste, true) });
  document.addEventListener("paste", onPaste, true);
  box.addEventListener("dragover", (e) => { if ([...(e.dataTransfer?.types || [])].includes("Files")) e.preventDefault(); });
  box.addEventListener("drop", (e) => {
    const file = imageFromTransfer(e.dataTransfer);
    if (!file) return;
    e.preventDefault();
    uploadDirect(file, 10, choose);
  });
  draw();
  return box;
}
